import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"

import { ResourceRoutingModule } from "./resource-routing.module"
import { ResourceComponent } from "./resource.component"

import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { SearchCollectionPageModule } from "../collection/search-collection-page/search-collection-page.module"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { AudioResourceComponent } from "./layouts/audio-resource/audio-resource.component"
import { DocumentResourceComponent } from "./layouts/document-resource/document-resource.component"
import { ImageResourceComponent } from "./layouts/image-resource/image-resource.component"
import { InteractiveResourceComponent } from "./layouts/interactive-resource/interactive-resource.component"
import { LessonPlanResourceComponent } from "./layouts/lesson-plan/lesson-plan-resource.component"
import { MediaGalleryResourceComponent } from "./layouts/media-gallery/media-gallery-resource.component"
import { VideoResourceComponent } from "./layouts/video-resource/video-resource.component"
import { AudioLargePosterImageComponent } from "./shared-components/audio-large-poster-image/audio-large-poster-image.component"
import { AudioPreviewComponent } from "./shared-components/audio-preview/audio-preview.component"
import { CurriculumTagsComponent } from "./shared-components/curriculum-tags/curriculum-tags.component"
import { MediaGalleryComponent } from "./shared-components/media-gallery/media-gallery.component"
import { MoreFromCollectionComponent } from "./shared-components/more-from-collection/more-from-collection.component"
import { RelatedResourcesComponent } from "./shared-components/related-resources/related-resources.component"
import { ResourceDetailsComponent } from "./shared-components/resource-details/resource-details.component"
import { ResourcesSubtitleComponent } from "./shared-components/resource-subtitle/resource-subtitle.component"
import { StandardsSectionComponent } from "./shared-components/standards-section/standards-section.component"
import { OpposedButtonsSetComponent } from "./shared-components/opposed-buttons-set/opposed-buttons-set.component"
import { ResourceDetailsService } from "../services/resource-details.service"
import { LessonContentComponent } from "./shared-components/support-material-panel/lesson-content/lesson-content.component"
import { SupportMaterialPanelComponent } from "./shared-components/support-material-panel/support-material-panel.component"
import { CollectionsDropdownComponent } from "./shared-components/collections-dropdown/collections-dropdown.component"
import { MediaGalleryButtonsComponent } from "./shared-components/media-gallery/media-gallery-buttons/media-gallery-buttons.component"
import { MatChipsModule } from "@angular/material/chips"
import { MatTooltipModule } from "@angular/material/tooltip"
import { IndexedDBService } from "../services/index-DB.service"
import { ResourcePreviewGuard } from "./guards/resource-preview.guard"
import { InteractivePreviewModalComponent } from "./shared-components/interactive-preview-modal/interactive-preview-modal.component"

@NgModule({
    declarations: [
        ResourceComponent,
        ResourceDetailsComponent,
        StandardsSectionComponent,
        RelatedResourcesComponent,
        CurriculumTagsComponent,
        ImageResourceComponent,
        VideoResourceComponent,
        LessonPlanResourceComponent,
        AudioResourceComponent,
        DocumentResourceComponent,
        MediaGalleryResourceComponent,
        MediaGalleryComponent,
        AudioPreviewComponent,
        DocumentResourceComponent,
        InteractiveResourceComponent,
        ResourcesSubtitleComponent,
        MoreFromCollectionComponent,
        AudioLargePosterImageComponent,
        OpposedButtonsSetComponent,
        LessonContentComponent,
        SupportMaterialPanelComponent,
        CollectionsDropdownComponent,
        MediaGalleryButtonsComponent,
        InteractivePreviewModalComponent,
    ],
    imports: [
        CommonModule,
        ResourceRoutingModule,
        SharedComponentsModule,
        NgbModule,
        SearchCollectionPageModule,
        MatChipsModule,
        MatTooltipModule,
    ],
    providers: [ResourceDetailsService, IndexedDBService, ResourcePreviewGuard],
})
export class ResourceModule {}
